
import Vue from "vue";
import AppTicketWrapper from "@/components/tickets/TicketWrapper.vue";
import { Ticket } from "../../models/tickets/ticket";
import { TicketService } from "../../services/ticket-service";
import AppChatMessages from "@/components/chat-components/ChatMessages.vue";
import AppMessageInput from "@/components/chat-components/MessageInput.vue";
import { ChatMessage } from "../../utils/chat-message";
import { ToolbarService } from "@/services/toolbar-service";

export default Vue.extend({
	data(){
		return {
			ticket: new Ticket(),
			messageInput: "",
			files: [] as File[],
			initialized: false,
			isSending: false
		};
	},
	props: {
		basePath: {
			type: String,
			default: "/support/tickets"
		}
	},
	computed: {
		messages():ChatMessage[] {
			return this.ticket.messages.map(m=>m.toChatMessage());
		}
	},
	watch: {
		"ticket.unreadUsers": {
			handler(){
				if (!this.initialized) return;
				if (!this.ticket.isRead()) {
					this.markAsRead();
				}
			}
		},
	},
	methods: {
		async sendMessage() {
			if (this.isSending) return;
			this.isSending = true;
			try {
				this.messageInput = this.messageInput.trim();
				if (this.messageInput == "" && this.files.length == 0) {
					return false;
				}
				await TicketService.sendMessage(this.ticket.id, this.messageInput, this.files);
				this.messageInput = "";
				this.files = [];
			} catch (err) {
			}finally{
				this.isSending = false;
			}
		},
		async addFiles(files:File[]){
			this.files.push(...files);
		},
		async markAsRead(){
			await TicketService.markAsRead(this.ticket.id);
		},
		async update(){
			this.$emit("update");
		}

	},
	async created(){
		this.ticket = await TicketService.getTicket(parseInt(this.$route.params.id));
		this.ticket.registerSocketEvents();
		if (!this.ticket.isRead()) {
			await this.markAsRead();
		}
		ToolbarService.title = this.$ct("ticket").toString();
		this.initialized = true;
	},
	destroyed(){
		this.ticket.deregisterSocketEvents();
	},
	components: {
		AppTicketWrapper,
		AppChatMessages,
		AppMessageInput
	},
	i18nEx: {
		componentPrefix: "components.tickets"
	}
});
